import React from "react"
import BaseBlockContent from "@sanity/block-content-to-react"

import { featured } from "../utils/image"

import styles from "./baseblockcontent.module.css"

const serializers = {
  types: {
    block(props) {
      switch (props.node.style) {
        case "h1":
          return <h1>{props.children}</h1>

        case "blockquote":
          return <blockquote className={styles.blockquote}>{props.children}</blockquote>

        default:
          return <p className={styles.p}>{props.children}</p>
      }
    },
    image(props) {
      return <img srcSet={`${featured(props.node, 400)} 360w, ${featured(props.node, 632)} 592w, ${featured(props.node, 807)} 767w, ${featured(props.node, 1022)} 992w`} src={featured(props.node, 1600)} alt={props.node.alt} className={styles.left} />
    },
    richImage(props) {
      return <img srcSet={`${featured(props.node, 400)} 360w, ${featured(props.node, 632)} 592w, ${featured(props.node, 807)} 767w, ${featured(props.node, 1022)} 992w`} src={featured(props.node, 1600)} alt={props.node.alt} className={(props.node.leftrightclass === 'left' ? styles.left : (props.node.leftrightclass === 'right' ? styles.right : (props.node.leftrightclass === 'vertical' ? styles.vertical : '')))} />
    },
  },
}

const BlockContent = ({ blocks }) => (
  <BaseBlockContent className={styles.baseBlockContent} blocks={blocks} serializers={serializers} />
)

export default BlockContent
